export const TEAMS_SV = {
    "Sweden": "Sverige",
    "Norway": "Norge",
    "Brazil": "Brasilien",
    "North Macedonia": "Nordmakedonien",
    "Northern Ireland": "Nordirland",
    "Palestine": "Palestina",
    "Iraq": "Irak",
    "Cameroon": "Kamerun",
    "Libya": "Libyen",
    "Estonia": "Estland",
    "Moldova": "Moldavien",
    "Luxembourg": "Luxemburg",
    "Spain": "Spanien",
    "France": "Frankrike",
    "Germany": "Tyskland",
    "Italy": "Italien",
    "Belgium": "Belgien",
    "Slovakia": "Slovakien",
    "Bulgaria": "Bulgarien",
    "Saudi Arabia": "Saudiarabien",
    "China PR": "Kina",
    "Australia": "Australien",
    "Korea Republic": "Sydkorea",
    "Jordan": "Jordanien",
    "Indonesia": "Indonesien",
    "Kyrgyz Republic": "Kyrgyzstan",
    "South Africa": "Sydafrika",
    "Croatia": "Kroatien",
    "Czech Republic": "Tjeckien",
    "Armenia": "Armenien",
    "Equatorial Guinea": "Ekvatorialguinea",
    "Morocco": "Marocko",
    "Poland": "Polen",
    "Romania": "Rumänien",
    "Latvia": "Lettland",
    "Albania": "Albanien",
    "Algeria": "Algeriet",
    "Greece": "Grekland",
    "Iceland": "Island",
    "Slovakia U21": "Slovakien U21",
    "Spain U21": "Spanien U21",
    "Italy U21": "Italien U21",
    "Romania U21": "Rumänien U21",
    "France U21": "Frankrike U21",
    "Poland U21": "Polen U21",
    "Georgia U21": "Georgien U21",
    "Ukraine U21": "Ukraina U21",
    "Denmark U21": "Danmark U21",
    "Czech Republic U21": "Tjeckien U21",
    "Germany U21": "Tyskland U21",
    "Slovenia U21": "Slovenien U21",
    "Netherlands U21": "Nederländerna U21",
    "Dominican Republic": "Dominikanska republiken",
    "Suriname": "Surinam",
    "Mexico": "Mexiko",
    "Canada": "Kanada",
    "Iceland W": "Island D",
    "Finland W": "Finland D",
    "Switzerland W": "Schweiz D",
    "Norway W": "Norge D",
    "Wales W": "Wales D",
    "Netherlands W": "Nederländerna D",
    "France W": "Frankrike D",
    "England W": "England D",
    "Belgium W": "Belgien D",
    "Italy W": "Italien D",
    "Spain W": "Spanien D",
    "Portugal W": "Portugal D",
    "Denmark W": "Danmark D",
    "Sweden W": "Sverige D",
    "Germany W": "Tyskland D",
    "Poland W": "Polen D",
    "Slovakia W": "Slovakien D",
    "Austria W": "Österrike D",
    "Austria": "Österrike",
    "Slovenia W": "Slovenien D",
    "Ukraine W": "Ukraina D",
    "Türkiye W": "Turkiet D",
    "Northern Ireland W": "Nordirland D",
    "Ireland W": "Irland D",
    "Serbia W": "Serbien D",
    "Czech Republic W": "Tjeckien D",
    "Turkey": "Turkiet",
    "Georgia": "Georgien",
    "Lithuania": "Litauen",
    "Netherlands": "Nederländerna",
    "Madagascar": "Madagaskar",
    "Central African Republic": "Centralafrikanska republiken",
    "Republic of Ireland": "Irland",
    "Hungary": "Ungern",
    "Slovenia": "Slovenien",
    "Denmark": "Danmark",
    "Scotland": "Skottland",
    "Switzerland": "Schweiz",
    "Ukraine": "Ukraina",
    "Kazakhstan": "Kazakstan",
    "Portugal": "Portugal",
    "Chile": "Chile",
    "Wales": "Wales",
    "United States": "USA",
    "Panama": "Panama",
    "Bosnia and Herzegovina": "Bosnien och Hercegovina",
    "Bolivia": "Bolivia",
    "England": "England",
    "New Zealand": "Nya Zeeland",
    "Egypt": "Egypten",
    "Venezuela": "Venezuela",
    "Argentina": "Argentina",
    "Honduras": "Honduras",
    "Guinea": "Guinea",
    "Burundi": "Burundi",
    "Cyprus": "Cypern",
    "Andorra": "Andorra",
    "Liechtenstein": "Liechtenstein",
    "Côte d'Ivoire": "Elfenbenskusten",
    "Serbia": "Serbien",
    "Guatemala": "Guatemala",
    "Lebanon": "Libanon",
    "Yemen": "Jemen",
    "Montenegro": "Montenegro",
    "Azerbaijan": "Azerbajdzjan",
    "Malta": "Malta",
    "Paraguay": "Paraguay",
    "Nicaragua": "Nicaragua",
    "Haiti": "Haiti",
    "Peru": "Peru",
    "Singapore": "Singapore",
    "Hong Kong": "Hongkong",
    "Mongolia": "Mongoliet",
    "Thailand": "Thailand",
    "Kuwait": "Kuwait",
    "Oman": "Oman",
    "Tajikistan": "Tadzjikistan",
    "India": "Indien",
    "Belarus": "Belarus",
    "Syria": "Syrien",
    "Bahrain": "Bahrain",
    "Tunisia": "Tunisien",
    "Uruguay": "Uruguay",
    "Iran": "Iran",
    "Senegal": "Senegal",
    "Congo DR": "Kongo-Kinshasa",
    "Ghana": "Ghana",
    "Uzbekistan": "Uzbekistan",
    "Colombia": "Colombia",
    "Cape Verde Islands": "Kap Verde",
    "Faroe Islands": "Färöarna",
    "Mauritania": "Mauretanien",
    "Israel": "Israel",
    "Sierra Leone": "Sierra Leone",
    "Zimbabwe": "Zimbabwe",
    "Uganda": "Uganda",
}

